import { takeLatest } from "redux-saga/effects";
import { createAction } from "redux-smart-actions";
import { deleteSaga } from "src/request/delete";
import { getSaga } from "src/request/get";
import { postSaga } from "src/request/post";
import { putSaga } from "src/request/put";
import { SagaActionParams, SagaGenericParams } from "src/request/types";
import * as Type from "./type";

export const getSpesificationListSaga = createAction(
  "GET_SPESIFICATION",
  ({ payload, params }: SagaActionParams<Type.SpesificationDto[]>) => ({
    payload,
    url: "/api/admin/webmodules" + (params ? params : ""),
  })
);
export const getSpesificationDetailsSaga = createAction(
  "GET_SPESIFICATION_DETAILS",
  ({ payload, id }: SagaActionParams<Type.SpesificationDetailDto>) => ({
    payload,
    url: "/api/admin/webmodules/" + id,
  })
);
export const createSpesificationSaga = createAction(
  "CREATE_SPESIFICATION",
  ({ payload, body }: SagaActionParams<Type.SpesificationDto>) => ({
    payload,
    url: "/api/admin/webmodules",
    body,
  })
);
export const updateSpesificationSaga = createAction(
  "UPDATE_SPESIFICATION",
  ({ payload, id, body }: SagaActionParams<Type.SpesificationDto>) => ({
    payload,
    url: "/api/admin/webmodules/" + id,
    body,
  })
);
export const deleteSpesificationSaga = createAction(
  "DELETE_SPESIFICATION",
  ({ payload, id }: SagaActionParams<Type.SpesificationDto>) => ({
    payload,
    url: "/api/admin/webmodules/" + id,
  })
);

const spesificationSaga = [
  takeLatest<any>(
    getSpesificationListSaga.toString(),
    (payload: SagaGenericParams<Type.SpesificationDto[]>) =>
      getSaga<Type.SpesificationDto[]>(payload)
  ),
  takeLatest<any>(
    getSpesificationDetailsSaga.toString(),
    (payload: SagaGenericParams<Type.SpesificationDetailDto>) =>
      getSaga<Type.SpesificationDetailDto>(payload)
  ),
  takeLatest<any>(
    createSpesificationSaga.toString(),
    (payload: SagaGenericParams<Type.SpesificationDto>) =>
      postSaga<Type.SpesificationDto>(payload)
  ),
  takeLatest<any>(
    updateSpesificationSaga.toString(),
    (payload: SagaGenericParams<Type.SpesificationDto>) =>
      putSaga<Type.SpesificationDto>(payload)
  ),
  takeLatest<any>(
    deleteSpesificationSaga.toString(),
    (payload: SagaGenericParams<any>) =>
      deleteSaga<Type.SpesificationDto>(payload)
  ),
];

export default spesificationSaga;
